import {
	EMAIL_STORAGE_KEY,
	LOCALSTORAGE_KEY_CHECKOUT,
	SHIPPING_ADDRESS_STORAGE_KEY,
	USER_STATUS_GUEST,
	USER_STATUS_LOGGED,
} from '../../../constants'

export const getLoginStatus = (isLoggedIn) => (isLoggedIn ? USER_STATUS_LOGGED : USER_STATUS_GUEST)

export const getUserInfo = ({ isLoggedIn, customer, defaultShippingCountry } = {}) => {
	const checkoutStorage = JSON.parse(window.localStorage.getItem(LOCALSTORAGE_KEY_CHECKOUT) || '{}')
	const { [EMAIL_STORAGE_KEY]: checkoutEmail, [SHIPPING_ADDRESS_STORAGE_KEY]: checkoutAddress } = checkoutStorage || {}

	/**
	 * Se l’utente è già andato a checkout e ha popolato l’indirizzo di spedizione -> utilizzo quello
	 * Se l’utente non è andato a checkout, ma ha un indirizzo predefinito -> utilizzo quello
	 * Se l’utente non ha un indirizzo predefinito, ma ha più di un indirizzo -> utilizzo l’indirizzo con ID più grande (ovvero, l’ultimo inserito)
	 * Se non c'è alcun indirizzo disponibile -> push del dato vuoto
	 */
	const address =
		checkoutAddress ??
		customer?.addresses?.find(({ defaultShipping }) => defaultShipping) ??
		customer?.addresses
			?.filter(({ countryCode } = {}) => countryCode === defaultShippingCountry)
			.sort((a, b) => b.id - a.id)?.[0] ??
		null

	return {
		address: {
			address: address?.street?.join(', ') ?? '',
			city: address?.city ?? '',
			country: address?.countryCode ?? '',
			first_name: address?.firstname ?? '',
			last_name: address?.lastname ?? '',
			postal_code: address?.postcode ?? '',
		},
		email: customer?.email ?? checkoutEmail ?? '',
		phone_number: address?.telephone ?? '',
		user_id: customer?.id ?? '',
		user_logged: getLoginStatus(isLoggedIn),
	}
}
